"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var popper_js_1 = __importDefault(require("popper.js"));

var react_1 = __importDefault(require("react"));

var Overlay =
/** @class */
function (_super) {
  __extends(Overlay, _super);

  function Overlay() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.state = {
      data: undefined
    };
    _this.popupRef = react_1.default.createRef();

    _this.updatePosition = function (data) {
      _this.setState({
        data: data
      });
    };

    return _this;
  }

  Overlay.prototype.componentDidMount = function () {
    var _this = this;

    requestAnimationFrame(function () {
      // tslint:disable-next-line:no-commented-code
      var container = _this.props.containerRef.current;
      var popper = _this.popupRef.current;

      if (popper) {
        _this._poperInstance = new popper_js_1.default(container, popper, {
          placement: 'bottom-start',
          onCreate: _this.updatePosition,
          onUpdate: _this.updatePosition,
          modifiers: {
            applyStyle: {
              enabled: false
            },
            offset: {
              offset: '-1',
              enabled: true
            }
          }
        });

        _this._poperInstance.scheduleUpdate();
      }
    });
  };

  Overlay.prototype.componentWillUnmount = function () {
    if (this._poperInstance) {
      this._poperInstance.destroy();
    }
  };

  Overlay.prototype.getPopperStyle = function (data) {
    if (!data) {
      return {};
    }

    var left = Math.round(data.offsets.popper.left);
    var top = Math.round(data.offsets.popper.top);
    var transform = "translate3d(" + left + "px, " + top + "px, 0)"; // Calculate TOP position

    var topMargin = 10;

    if (data.offsets.reference.top > data.offsets.popper.top) {
      topMargin *= -1;
    }

    return {
      position: data.offsets.popper.position,
      transform: transform,
      WebkitTransform: transform,
      top: topMargin,
      left: 0,
      visibility: 'visible',
      display: 'flex',
      opacity: 1
    };
  };

  Overlay.prototype.render = function () {
    var _a = this.props,
        classNames = _a.classNames,
        children = _a.children,
        containerRef = _a.containerRef,
        selectedDay = _a.selectedDay,
        other = __rest(_a, ["classNames", "children", "containerRef", "selectedDay"]);

    return react_1.default.createElement("div", __assign({
      ref: this.popupRef,
      style: this.getPopperStyle(this.state.data),
      className: classNames.overlay
    }, other), children);
  };

  return Overlay;
}(react_1.default.Component);

exports.default = Overlay;